import { useToggle } from '@oforce/global-components';
import React from 'react';
import { Tooltip } from 'reactstrap';

export default function FieldTooltip({ field, safeKey }) {
    const { tooltip, example } = field;
    const [show, toggle] = useToggle(false);

    if (!tooltip) return null;

    return (
        <Tooltip
            key={`tooltip-${safeKey}`}
            target={`badge-${safeKey}`}  // used the sanitized ID here!
            placement="top"
            isOpen={show}
            toggle={toggle}
        >
            <p>{tooltip}</p>
            {example && <p>{example}</p>}
        </Tooltip>
    );
}
